module.exports = __webpack_public_path__ + "img/prev.a8313bb4.png";